export const SET_USER_DATA = "USER:SET_USER_DATA"
export const SET_BALANCE = "USER:SET_BALANCE"
